export default __webpack_public_path__ + "static/media/A5_LANDSCAPE_ORI_DF.e5a54d8f.png";